import { slugify } from "../../utils/slugify.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { ProductCategory } from "../ProductCategory.js";
import { categorySearchParamLocalized } from "./categorySearchParamLocalized.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/produkty" as const,
} satisfies LocalizedString;

export function getProductsCataloguePath(
	locale: Locale,
	categories: Pick<ProductCategory, "name" | "id">[] = [],
): string {
	const searchParams = new URLSearchParams();
	for (const { name, id } of categories) {
		searchParams.append(categorySearchParamLocalized[locale], `${slugify(name)}-${id.slice(0, 4)}`);
	}
	return `${getPathInLocale(locale, pathMap)}${searchParams.size > 0 ? "?" : ""}${searchParams}`;
}
